import styled, { keyframes } from "styled-components";

const switchAnim = keyframes`
  from{
    transform:rotate(40deg)
  }
  to{
    transform:rotate(0deg)
  }
`;

export const Caret = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 3px 0 0 0;
  cursor: pointer;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transform: ${props => (props.isOpen ? "rotate(0deg)" : "rotate(180deg)")};
  transition: transform 0.2s ease, opacity 0.15s ease;

  @media (max-width: 500px) {
    margin-right: 0px;
  }
`;

export const ProfileIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
  width: fit-content;
  border-radius: 6px;
  cursor: pointer;
  transform: translateY(-4px);

  .profile-name {
    font-size: ${props => props.theme.p2b.fs};
    font-family: ${props => props.theme.p2b.ff};
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: capitalize;
  }

  .profile-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .profile-avatar {
    transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  &:hover {
    background-color: #282828;
  }

  &:hover .profile-avatar {
    transform: scale(1.2);
  }

  &:hover ${Caret} {
    opacity: 1;
  }
`;

export const CloseIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-left: 16px;
  margin-top: -8px;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
    animation: ${switchAnim} 0.4s ease-in-out;
  }
`;

export const BurgerButton = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  width: 42px;
  height: 42px;
  border-radius: ${props => props.theme.br.md};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${props => props.theme.backgroundLight};
  }

  img {
    display: block;
  }
`;
